import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { toast } from "react-toastify";

class VinicaSecondModalForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isUtilizadorPrincipal: false,
      idProperty: "",
      entity: {},
    };
  }

  /* Esta é a primeira etapa após o construxctor para carregar este componente  */

  componentDidMount() {
    this.defaultLoader();
  }

  defaultLoader = () => {
    let isUtilizadorPrincipal = false;
    let idProperty = "";
    if (this.props.IdenUser[this.props.tab] === this.props.entity.nif) {
      isUtilizadorPrincipal = true;
      if (this.props.tab === "Instalação")
        idProperty = this.props.IdenUser["instalacaoDetail"];
      else idProperty = this.props.IdenUser["utilizadorDetail"];
    }
    this.setState({
      entity: this.props.entity,
      isUtilizadorPrincipal,
      idProperty,
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.date !== this.props.date) {
      this.defaultLoader();
    }
  }

  handleCheck = (e) => {
    let idProperty = "";
    let isUtilizadorPrincipal = this.state.isUtilizadorPrincipal;
    if (e.target.name === "verbal") idProperty = "verbal";
    if (e.target.name === "documental") idProperty = "documental";
    if (e.target.name === "utilizadorPrincipal") {
      isUtilizadorPrincipal = !isUtilizadorPrincipal;
      if (isUtilizadorPrincipal) idProperty = "verbal";
    }

    if (!isUtilizadorPrincipal) idProperty = "";
    this.setState({
      idProperty,
      isUtilizadorPrincipal,
    });
  };

  handleSubmit = () => {
    let tab = this.props.tab;
    let IdenUser = this.props.IdenUser;
    let isUtilizadorPrincipal = this.state.isUtilizadorPrincipal;
    let entity = this.state.entity;
    let idProperty = this.state.idProperty;
    let data = this.props.data;
    if (!isUtilizadorPrincipal && entity.nif === IdenUser[tab]) {
      toast.error("main user mandatory");
      return;
    }
    this.props.setIdenUser(entity.nif, idProperty, tab);
    this.props.closePopup();
  };
  //Associar proprietário
  render() {
    if (this.props.tab === "Instalação" || this.props.tab === "Utilizadores") {
      return (
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title pl-0">Associar Proprietário</h4>
            <Button
              onClick={this.handleSubmit}
              type="button"
              primary
              className="btn-ivdp-primary btn-success btn-sm mr-3"
              disabled={!this.state.isUtilizadorPrincipal}
            >
              Guardar
            </Button>
            <Button
              onClick={() => this.props.closePopup()}
              className="remoove k-primary btn-ivdp-secondary btn-theme cursor-pointer mr-2"
            >
              Cancelar
            </Button>
          </div>
          {/* <div className="modal-body">
            <div className="container">
              <div className="my-3">
                <p>Nº Entidade</p>
                <h5>{this.props.entity.nif}</h5>
              </div>
              <div className="my-3">
                <p>Nome</p>
                <h5>{this.props.entity.nome}</h5>
              </div>
              <div>
                  <div className="custom-control custom-checkbox">
                    <input 
                      type="checkbox" 
                      checked={this.state.isUtilizadorPrincipal} 
                      id="utp"
                      className="custom-control-input"
                      name="utilizadorPrincipal" 
                      onChange={(e) => this.handleCheck(e)} 
                    />
                    <label className="custom-control-label" htmlFor="utp">Proprietário principal</label><br />
                  </div>
                {
                  this.state.isUtilizadorPrincipal &&
                  this.props.tab === "Instalação" &&
                  (
                    <div style={{marginTop: "30px"}}>
                      <label><strong>Ident. proprietário</strong></label>
                      <ul style={{ listStyleType: 'none' }}>
                        
                        <li>
                          <div className="custom-control custom-checkbox">
                            <input 
                              type="checkbox" 
                              value=""
                              id="verbal"
                              className="custom-control-input"
                              name="verbal" 
                              checked={this.state.idProperty === 'verbal'} 
                              onClick={(e) => this.handleCheck(e)}
                            />
                            <label className="custom-control-label mr-2" htmlFor="verbal">Verbal</label>
                          </div>
                        </li>
                        
                        <li>
                          <div className="custom-control custom-checkbox">
                            <input 
                              type="checkbox" 
                              value="" 
                              id="documental"
                              className="custom-control-input"
                              name="documental"
                              checked={this.state.idProperty === 'documental'} 
                              onClick={(e) => this.handleCheck(e)}
                            />
                            <label className="custom-control-label mr-2" htmlFor="documental">Documental</label>
                          </div>
                        </li>
                      
                      </ul>
                    </div>
                  )
                }
              </div>
            </div>
          </div> */}
          <div className="modal-body">
            <div className="details">
              <div className="row mt-3">
                <div className="col-md-12">
                  <p>Nº Entidade</p>
                  <h3>{this.props.entity.nif}</h3>
                </div>
                <div className="col-md-12">
                  <p>Nome</p>
                  <h3>{this.props.entity.nome}</h3>
                </div>
                <div className="col-md-12">
                  <div className="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      checked={this.state.isUtilizadorPrincipal}
                      id="utp"
                      className="custom-control-input"
                      name="utilizadorPrincipal"
                      onChange={(e) => this.handleCheck(e)}
                    />
                    <label className="custom-control-label" htmlFor="utp">
                      Proprietário principal
                    </label>
                   </div>
                </div>
                <div className="col-md-12">
                {
                  this.state.isUtilizadorPrincipal &&
                  this.props.tab === "Instalação" &&
                  (
                    <div style={{marginTop: "30px"}}>
                      <p>Ident. proprietário</p>
                      <ul style={{ listStyleType: 'none' }}>
                        
                        <li>
                          <div className="custom-control custom-checkbox">
                            <input 
                              type="checkbox" 
                              value=""
                              id="verbal"
                              className="custom-control-input"
                              name="verbal" 
                              checked={this.state.idProperty === 'verbal'} 
                              onClick={(e) => this.handleCheck(e)}
                            />
                            <label className="custom-control-label mr-2" htmlFor="verbal">Verbal</label>
                          </div>
                        </li>
                        
                        <li>
                          <div className="custom-control custom-checkbox">
                            <input 
                              type="checkbox" 
                              value="" 
                              id="documental"
                              className="custom-control-input"
                              name="documental"
                              checked={this.state.idProperty === 'documental'} 
                              onClick={(e) => this.handleCheck(e)}
                            />
                            <label className="custom-control-label mr-2" htmlFor="documental">Documental</label>
                          </div>
                        </li>
                      
                      </ul>
                    </div>
                  )
                }
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default VinicaSecondModalForm;
